import { Text } from '@/components/atoms/Text';
import { Title } from '@/components/atoms/Title';
import styled from '@emotion/styled';

export const Container = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: ${({ theme }) => theme.spacing[2]};
`;

export const FullwidthContainer = styled.div`
    width: 100%;
`;

export const HalfwidthContainer = styled.div`
    width: calc(50% - ${({ theme }) => theme.spacing[1]});
    ${({ theme }) => theme.breakpoints.mobile} {
        width: 100%;
    }
`;

export const StyledLabel = styled(Text)`
    ${({ theme }) => theme.font.caption.bold};
    line-height: 20px;
    margin-bottom: ${({ theme }) => theme.spacing[1]};
`;

export const StyledTitle = styled(Title)`
    overflow-wrap: break-word;
`;
